"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
export default function Error(t0) {
  const $ = _c(7);
  const {
    error,
    reset
  } = t0;
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      console.error(error);
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h1 className="font-poppins text-2xl font-semibold text-primary dark:text-white">Something went wrong</h1>;
    t4 = <p className="max-w-md font-open-sans text-sm text-gray-500 dark:text-gray-400">An unexpected error occurred while loading this page. Please try again.</p>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== reset) {
    t5 = <div className="flex min-h-[60dvh] w-full flex-col items-center justify-center gap-4 bg-white px-4 text-center dark:bg-gray-950">{t3}{t4}<button type="button" onClick={reset} className="rounded-full bg-primary px-6 py-2.5 text-sm font-medium text-white transition-opacity hover:opacity-90">Try again</button></div>;
    $[5] = reset;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}